// src/App.js
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhyUs from "./components/WhyUs";
import Gyros from "./components/Gyros";
import Dessert from "./components/Dessert";
import BulkOrder from "./components/BulkOrder";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import PizzaMenu from "./components/Pizzamenu";
import DiscountsPage from "./components/DiscountsPage";
import Seo from "./components/Seo/Seo";
import StructuredData from "./components/Seo/StructuredData";
import MenuIntro from "./components/MenuIntro";
import Franchise from "./components/Franchise";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ---------------------------------------------------------
// WEBSITE BASE (DEBRECEN)
// ---------------------------------------------------------
const BASE_URL = "https://debrecenipizza.hu";

// ---------------------------------------------------------
// SCHEMAS (UPDATED FOR DEBRECEN + HAMAROSAN)
// ---------------------------------------------------------

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Pizza Home Debrecen",
  url: BASE_URL,
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Pizza Home Debrecen",
  url: BASE_URL,
  logo: `${BASE_URL}/android-chrome-512x512.png`,
  primaryImageOfPage: {
    "@type": "ImageObject",
    url: `${BASE_URL}/images/hero.webp`,
    width: 1200,
    height: 630,
  },
  image: [
    `${BASE_URL}/images/whyus.webp`,
    `${BASE_URL}/images/hero.webp`,
  ],
  sameAs: [
    "https://www.facebook.com/pizzahomedebrecen",
    "https://www.instagram.com/pizzahomedebrecen",
  ],
};

const restaurantSchema = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name: "Pizza Home Debrecen",
  logo: `${BASE_URL}/android-chrome-512x512.png`,
  image: `${BASE_URL}/android-chrome-512x512.png`,
  url: `${BASE_URL}/`,
  telephone: "Hamarosan",
  servesCuisine: ["Pizza", "Gyros"],
  priceRange: "Ft",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Hamarosan",
    addressLocality: "Debrecen",
    postalCode: "Hamarosan",
    addressCountry: "HU",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "Hamarosan",
      closes: "Hamarosan",
    },
  ],
  acceptsReservations: "False",
  menu: `${BASE_URL}/etlap`,
};

const offerCatalogSchema = {
  "@context": "https://schema.org",
  "@type": "OfferCatalog",
  name: "Pizza Home Debrecen – Étlap",
  url: `${BASE_URL}/etlap`,
  image: `${BASE_URL}/images/menu/pizzas/pizza-2.webp`,
};

// ---------------------------------------------------------
// SCROLL TO TOP
// ---------------------------------------------------------
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// ---------------------------------------------------------
// PAGES
// ---------------------------------------------------------

function HomePage() {
  return (
    <>
      <Seo
        title="Pizza Debrecen – Hamarosan nyitunk!"
        description="A Pizza Home hamarosan megnyílik Debrecenben! Vékony tésztás pizzák, gyros tálak és óriáspalacsinták – frissen készítve, gyorsan házhozszállítva. Hamarosan!"
        path="/"
      />

      <StructuredData data={restaurantSchema} />

      <Hero />
      <WhyUs />
      <Gyros />
      <Dessert />
      <BulkOrder />
    </>
  );
}

function EtlapPage() {
  return (
    <>
      <Seo
        title="Pizza Debrecen étlap – Hamarosan"
        description="Nézd meg a Pizza Home Debrecen hamarosan elérhető étlapját! Pizzák, gyrosok, desszertek – minden frissen készítve."
        path="/etlap"
      />
      <StructuredData data={offerCatalogSchema} />
      <MenuIntro />
      <PizzaMenu />
    </>
  );
}

function DiscountsPagewithseo() {
  return (
    <>
      <Seo
        title="Pizza Debrecen kedvezmények – Hamarosan"
        description="Törzsvásárlói és csoportos kedvezmények hamarosan elérhetők Debrecenben! Gyűjtsd a házikókat, és élvezd a speciális ajánlatokat."
        path="/aktualis-akciok"
      />
      <DiscountsPage />
    </>
  );
}

function FranchisePage() {
  return (
    <>
      <Seo
        title="Pizza Home Franchise | Működő pizzéria üzleti modell"
        description="Csatlakozz egy működő pizzéria franchise rendszerhez! Pizza Home: bevált folyamatok, online marketing támogatás és közös beszerzés."
        path="/franchise"
        image="/og.png"
      />

      <StructuredData
        data={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Pizza Home Franchise",
          "url": `${BASE_URL}/franchise`,
          "description":
            "Pizza Home franchise – működő pizzéria rendszer, közös marketinggel, beszállítókkal és bizonyított üzleti folyamattal."
        }}
      />

      <Franchise />
    </>
  );
}


// ---------------------------------------------------------
// MAIN APP
// ---------------------------------------------------------

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Navbar />
      <StructuredData data={[websiteSchema, orgSchema]} />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/etlap" element={<EtlapPage />} />
        <Route path="/aktualis-akciok" element={<DiscountsPagewithseo />} />
        <Route path="/franchise" element={<FranchisePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
      <CookieBanner />
    </BrowserRouter>
  );
}
